import { render, staticRenderFns } from "./CompProfileEditCoupleInformation.vue?vue&type=template&id=12533312&scoped=true"
import script from "./CompProfileEditCoupleInformation.vue?vue&type=script&setup=true&lang=js"
export * from "./CompProfileEditCoupleInformation.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12533312",
  null
  
)

export default component.exports